<template>
	<div class="checkbox-wrapper">
		<label :for="id" class="checkbox-label">
			<input
				type="checkbox"
				:id="id"
				:checked="modelValue"
				@change="handleChange"
				class="hidden-checkbox"
			/>

			<span
				class="size-5 grid place-items-center border-2"
				:class="{
					'rounded-full': rounded,
					'rounded-md': !rounded
				}"
				:style="{ borderColor: color ?? '#676767' }"
			>
				<svg
					v-if="modelValue"
					width="10"
					height="8"
					viewBox="0 0 10 8"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M1.45801 4.00091L3.81634 6.35924L8.54134 1.64258"
						:stroke="color ?? '#676767'"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</span>

			<span v-if="label" class="checkbox-text">{{ label }}</span>
		</label>
	</div>
</template>

<script>
export default {
	name: "Checkbox",
	props: {
		rounded: {
			type: Boolean,
			default: false
		},
		modelValue: {
			type: Boolean,
			required: true
		},
		label: {
			type: String,
			default: null
		},
		id: {
			type: String,
			required: true
		},
		color: {
			type: String,
			default: null
		}
	},
	methods: {
		handleChange(event) {
			this.$emit("update:modelValue", event.target.checked);
		}
	}
};
</script>

<style scoped>
.checkbox-wrapper {
	display: inline-block;
}

.hidden-checkbox {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	opacity: 0;
}

.checkbox-label {
	display: flex;
	align-items: center;
	cursor: pointer;
}

.checkbox-custom {
	width: 20px;
	height: 20px;
	border: 2px solid #333;
	border-radius: 3px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	margin-right: 8px;
}

.checkmark {
	width: 14px;
	height: 14px;
	fill: #333;
}

.checkbox-text {
	font-size: 16px;
}
</style>
